import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Buffer3384y49aj0pxr as Buffer } from '../../../../../../okio-parent-okio/okio/Buffer.mjs';
import { BufferedSinkJsonWriter1xl4ankftitqq as BufferedSinkJsonWriter } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/BufferedSinkJsonWriter.mjs';
import { writeAny16i13331zbqlc as writeAny } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonWriters.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var TextClientMessageClass;
function TextClientMessage() {
  if (TextClientMessageClass === VOID) {
    class $ {
      constructor(text) {
        this.k66_1 = text;
      }
    }
    initMetadataForClass($, 'TextClientMessage');
    TextClientMessageClass = $;
  }
  return TextClientMessageClass;
}
var DataClientMessageClass;
function DataClientMessage() {
  if (DataClientMessageClass === VOID) {
    class $ {}
    initMetadataForClass($, 'DataClientMessage');
    DataClientMessageClass = $;
  }
  return DataClientMessageClass;
}
function toClientMessage(_this__u8e3s4) {
  // Inline function 'com.apollographql.apollo.api.json.buildJsonString' call
  var buffer = new (Buffer())();
  var $this$buildJsonString = new (BufferedSinkJsonWriter())(buffer, null);
  writeAny($this$buildJsonString, _this__u8e3s4);
  // Inline function 'kotlin.let' call
  var it = buffer.k3w();
  return new (TextClientMessage())(it);
}
//region block: exports
export {
  DataClientMessage as DataClientMessage3splhk6u8gldd,
  TextClientMessage as TextClientMessage15942w7lyj1yt,
  toClientMessage as toClientMessage6qtheyrb1jpy,
};
//endregion

//# sourceMappingURL=ClientMessage.mjs.map
